// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"TabSectionB_TheComp__epPmD"};